import { render, staticRenderFns } from "./m_bottom.vue?vue&type=template&id=52d83e74&"
import script from "./m_bottom.vue?vue&type=script&lang=js&"
export * from "./m_bottom.vue?vue&type=script&lang=js&"
import style0 from "./m_bottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports